module.exports = __webpack_public_path__ + "static/client-work-banner-overlay-ce5ed300a6b7dc7d2581a69f83aee3f3.png";